var React = require('react');

function Account2025 (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9.49999","cy":"4.96667","r":"3.96667","stroke":"black","strokeWidth":"1.7","key":0}),React.createElement("path",{"d":"M1 18C1.6839 14.1407 5.22921 11.2 9.5 11.2C13.7708 11.2 17.3161 14.1407 18 18H1Z","stroke":"black","strokeWidth":"1.7","strokeLinejoin":"round","key":1})]);
}

Account2025.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = Account2025;

Account2025.default = Account2025;
